import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

interface Props {
  billAmount: number;
  serviceFee?: number;
  totalAmount?: number;
  formatCurrency: (n: number) => string;
}

const PaybosFeeBreakdown: React.FC<Props> = ({
  billAmount,
  serviceFee = 0,
  totalAmount,
  formatCurrency,
}) => {
  const total = totalAmount ?? billAmount + serviceFee;

  return (
    <Box sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
      <Box display="flex" justifyContent="space-between" mb={0.5}>
        <Typography variant="body2" color="text.secondary">
          Nominal tagihan
        </Typography>
        <Typography variant="body2">{formatCurrency(billAmount)}</Typography>
      </Box>
      <Box display="flex" justifyContent="space-between" mb={0.5}>
        <Typography variant="body2" color="text.secondary">
          Biaya layanan QRIS
        </Typography>
        <Typography variant="body2">
          {serviceFee > 0 ? formatCurrency(serviceFee) : 'Rp 0'}
        </Typography>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box display="flex" justifyContent="space-between">
        <Typography variant="subtitle2" fontWeight={700}>
          Total dibayar
        </Typography>
        <Typography variant="subtitle2" fontWeight={700} color="primary.main">
          {formatCurrency(total)}
        </Typography>
      </Box>
    </Box>
  );
};

export default PaybosFeeBreakdown;
